import { render, staticRenderFns } from "./ci_resources_list.vue?vue&type=template&id=dab8fdc4"
import script from "./ci_resources_list.vue?vue&type=script&lang=js"
export * from "./ci_resources_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports